import { render, staticRenderFns } from "./Step5.vue?vue&type=template&id=ff18e0e6"
import script from "./Step5.vue?vue&type=script&lang=ts"
export * from "./Step5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports